quoteModule.factory('contractCreationService', ['$rootScope', '$http','AppSettings','commonRESTCallService', 'erateSessionVarsService',
    'imSessionVarsService', '$q', 'rateQuoteCoordService','rateQuotePersistService','rateQuoteScenariosService',
    'contractInfoService','quoteContractArchivalService', 'financeService', 'financeContractService',
    'usageEventsService',
function ($rootScope, $http, appSettings, commonRESTCallService, erateSessionVarsSvc,
    imSessionVarsService, $q, rateQuoteCoordService, rateQuotePersistService, rateQuoteScenariosService,
    contractInfoService,quoteContractArchivalService, financeService, financeContractService,
    usageEventsService ) {

        var contractCreationService = {};
        //state variables
        contractCreationService.allowCreateNewContract = {}; // index by quote id
        contractCreationService.creationStatuses = {}; // index by quote id
        contractCreationService.creationStatusesSPP = {}; // index by quote id
        contractCreationService.contractNumbers = {};  // index by quote id
        contractCreationService.requiredFieldsMissingError = "Required fields missing";
        contractCreationService.contractsProcessing = {
            started : false,
            completedLookup : false,
            contractsCreated : false,
            officialContractsCreated : false
        };
        //initialization
        contractCreationService.initContractInfo = function(){
            contractInfoService.contractsPerQuote = {};
            contractInfoService.contractInfo = {};
            contractCreationService.allowCreateNewContract = {};
            //contractCreationService.contractsProcessing.started = false;
            contractCreationService.contractsProcessing.completedLookup = false;
            contractCreationService.contractsProcessing.contractsCreated = false;
            contractCreationService.contractsProcessing.officialContractsCreated = false;
        }
        //starting contracting
        contractCreationService.waitForContractChecks = function(){
            contractCreationService.contractsProcessing.completedLookup = false;
        }
        //done contracting
        contractCreationService.clearContractsChecks = function(){
            contractCreationService.contractsProcessing.started = false;
            contractCreationService.contractsProcessing.completedLookup = true;
        }

        // *** contract creation status methods ****
        //initialization
        contractCreationService.clearCreationStatuses = function(){
            contractCreationService.creationStatuses = {};
            contractCreationService.creationStatusesSPP = {};
        }
        //set contract status for a quote
        contractCreationService.setCreationStatus = function(quoteId, status) {
            contractCreationService.creationStatuses[quoteId] = status;
        }
        //set SPP contract status for a quote
        contractCreationService.setCreationStatusSPP = function(quoteId, statusSPP) {
            contractCreationService.creationStatusesSPP[quoteId] = statusSPP;
        }
        //get contract status for a quote
        contractCreationService.getCreationStatus = function(quoteId) {
            return contractCreationService.creationStatuses[quoteId];
        }
        //get contract status for a quote
        contractCreationService.getCreationStatusSPP = function(quoteId) {
            return contractCreationService.creationStatusesSPP[quoteId];
        }
        contractCreationService.clearACreationStatus = function(quoteId) {
            contractCreationService.creationStatuses[quoteId] = undefined;
            contractCreationService.creationStatusesSPP[quoteId] = undefined;
        }
        //do we have statuses chosen for a quote
        contractCreationService.contractStatusesReady = function(quoteIds){
            quoteIds.forEach(function(quoteid){
                if (contractCreationService.creationStatuses[quoteid])
                    return true;
            });
            return false;
        }


        // **** contract number methods - for alt finance ****
        //initialization
        contractCreationService.clearContractNumbers = function(){
            contractCreationService.contractNumbers = {};
        }
        //set contract status for a quote
        contractCreationService.setContractNumber = function(quoteId, number) {
            contractCreationService.contractNumbers[quoteId] = number;
        }
        //get contract status for a quote
        contractCreationService.getContractNumber = function(quoteId) {
            return contractCreationService.contractNumbers[quoteId];
        }


    //contract creation processing
        contractCreationService.beginContractForChosenQuotes = function(isMenuIntegrated){

            var deferred = $q.defer();

            var dateOfSale = new Date();
            if (rateQuoteCoordService.VehicleData && rateQuoteCoordService.VehicleData.dateOfSale)
                dateOfSale = new Date(rateQuoteCoordService.VehicleData.dateOfSale);
            rateQuotePersistService.removeAllButCurrentScenario(isMenuIntegrated)
                .then(
                function downToOneScenarioForContracting(results){

                    var quotes = rateQuoteCoordService.getQuotesForScenario(rateQuoteScenariosService.getCurrentScenario());

                    if (!(quotes && quotes.length > 0)) {
                        throw new Error('No quotes to create contracts');
                    }
                    var allQuoteIds = quotes
                        .filter(function (quote){ return contractCreationService.getCreationStatus(quote.RatedTerms[0].SavedRateUniqueId);})
                        .map(function(quote) { return quote.RatedTerms[0].SavedRateUniqueId; })

                    var keyCareContractPrefix = quotes.reduce(function(result, quote)  { return result || getRatedProductFlexField(quote, 'KEYCARECONTRACTPREFIX'); }, null);
                    var keyCareContractLength  = quotes.reduce(function(result, quote)  { return result || getRatedProductFlexField(quote, 'KEYCARECONTRACTLENGTH'); }, null);
                    quotes = null;  // data not needed in closures below

                    // null means no key care products being contracted or provider doesn't require a prefix
                    contractInfoService.contractProductInfo.keycareContractPrefix = keyCareContractPrefix || "";
                    contractInfoService.contractProductInfo.keycareContractLength = parseInt(keyCareContractLength) || "";

                    contractCreationService.attemptCreateContract(allQuoteIds, dateOfSale, false)
                    .then(
                        function contractsCreated() {
                           allQuoteIds.forEach(function (quoteId) {contractInfoService.quoteQueueInfo.loading[quoteId] = false;});
                            deferred.resolve(true);
                        },
                        function checkNeedForPreFlight(error) {
                            contractInfoService.quoteQueueInfo.selectedQuotes = allQuoteIds;

                            if(error === contractCreationService.requiredFieldsMissingError) {
                                // throw up preflight info with required fields
                                // this has a "hidden" dependency on the contractCreationService correctly transferring the
                                // required fields information to the contract info service.
                                deferred.resolve(false);
                            } else {
                                deferred.reject(error);
                            }
                        })
                        .catch(function(err){ deferred.reject(err);} );
                },
                function(err){
                    deferred.reject(err);
                }
            );

            return deferred.promise;
        }

    function CheckGap() {
        var isProdGap = false;
        for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {
            if (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('GAP') > -1) {
               /* errorMsg = {
                    reason: 'Choose a Lender to continue.'
                };*/
                isProdGap = true;
                break;
            }

        }
        return isProdGap;
    }

    function getProviderDealerAmtFinStates() {
        var states =[];
        var  dealerStates = JSON.parse(imSessionVarsService.getCurrentProviderSettings('GAP-Amount-Financed-States'));
        if (dealerStates != null ) {
            states = _.filter(dealerStates, function (n) {
                return n.Key == "States"
            })[0].Value;
        }
        return states;
    }


    function getRatedProductFlexField(quote, fieldName) {
           var flexFields = quote.RatedProduct
               && quote.RatedProduct.PartnerSpecificFields
               && quote.RatedProduct.PartnerSpecificFields.FlexFields
               && quote.RatedProduct.PartnerSpecificFields.FlexFields;

           if (!angular.isArray(flexFields))
                 return angular.undefined;

           var field = _.find(flexFields, function (fieldObj) { return fieldObj.FieldName == fieldName});

           return field && field.FieldValue;
       }

        //try to create contracts, but if we are missing data, abort to "preflight"
    contractCreationService.attemptCreateContract = function(quoteIds, dateOfSale,allowContract) {
            var deferred = $q.defer();
            contractInfoService.clearRequiredFields();

            contractCreationService.contractsProcessing.started = true;

            var encryptedIds = quoteIds.map(function(quoteId){
                return rateQuotePersistService.getEncryptedQuoteId(quoteId);
            }).join(',');

           var verifyQuoteInfoUrl = appSettings.startSPANPlusSvcURL + 'contractpreflight/' + encryptedIds;
            commonRESTCallService.getFromServer(verifyQuoteInfoUrl)
            .success(function examineRequiredFields(requiredFields) {
                if(((requiredFields.length > 0) || (CheckGap() && rateQuoteCoordService.LenderData.selectedLender.name == 'Not Applicable')) || !allowContract) {
                    var mappedRequiredFields = mapRequiredFields(requiredFields);
                    transferRequiredFields(mappedRequiredFields);
                    mappedRequiredFields = null;
                    contractCreationService.contractsProcessing.started = false;

                    if ((requiredFields.length < 1 && allowContract)) {
                        if (rateQuoteCoordService.LenderData.selectedLender.name == 'Not Applicable') {
                            var errorMsg = {
                                reason: 'Choose a Lender to continue.'
                            };
                            deferred.reject(errorMsg);
                        }
                    }
                    else {
                        deferred.reject(contractCreationService.requiredFieldsMissingError);
                    }
                } else {
                    // success! there were no required fields missing.
                    // can't contract yet - we need to check alternate financing
                    //
                    //wbh 8/12/2016 - only do bank info window for those OFFICIAL alt financing contracts
                    // (COM-11)
                    var altFinancingAcceptedQuotes = quoteIds.filter(function(quoteId) {
                        var financedQuote = financeService.getFinancedQuoteInfoById(quoteId);
                        return financedQuote && financedQuote.financingInfo.accepted && contractCreationService.getCreationStatus(quoteId) === 'OFFICIAL';
                    });

                    altFinancingAcceptedQuotes.forEach(function(quoteId) {
                        financeContractService.getContractNumber(quoteId)
                            .then( function(contractNumber) {
                                // returned contract number should be null if provider does not support requesting a specific contract number
                                financeContractService.buildFinancingContractUrl(contractNumber)
                                    .then(function(url) {
                                        contractCreationService.setContractNumber(quoteId,  contractNumber);
                                        contractInfoService.quoteQueueInfo.bankInfoRequired[quoteId] = url;
                                    });
                            });
                    });

                    // anything thats left
                    var remainingQuoteIds = quoteIds.filter(function(quoteId) { return altFinancingAcceptedQuotes.indexOf(quoteId) < 0; });

                    if(remainingQuoteIds.length == 0) {
                        // nothing left to do
                        contractCreationService.contractsProcessing.started = false;
                        deferred.resolve();
                    } else {
                        // Let's go ahead and get the contracts
                        var draftQuoteIds = remainingQuoteIds.filter(function (quoteId) {
                            return contractCreationService.getCreationStatus(quoteId) === 'DRAFT';
                        });
                        var officialQuoteIds = remainingQuoteIds.filter(function (quoteId) {
                            return contractCreationService.getCreationStatus(quoteId) === 'OFFICIAL';
                        });

                        var createPromises = [];
                        if (draftQuoteIds && draftQuoteIds.length > 0){
                            var promDraft = contractCreationService.generateContractForQuotes(draftQuoteIds, true, dateOfSale);
                            createPromises.push(promDraft);
                        }
                        if (officialQuoteIds && officialQuoteIds.length > 0){
                            var promOfficial = contractCreationService.generateContractForQuotes(officialQuoteIds, false, dateOfSale);
                            createPromises.push(promOfficial);
                        }
                        $q.all(createPromises)
                            .then(
                                function completedCreatingContracts(data) {
                                    contractCreationService.contractsProcessing.started = false;
                                    //once we create the contracts, we should clear out
                                    // their creation statuses - to prevent re-submitting
                                    // the contract when new products are added
                                    contractCreationService.clearCreationStatuses();
                                    draftQuoteIds = officialQuoteIds = null;
                                    deferred.resolve(data);
                                },
                                function(error) {
                                    var errorMsg = {
                                        reason: error[0] || 'Unknown error while generating contracts'
                                    };
                                    draftQuoteIds = officialQuoteIds = null;

                                    var getValidFieldsUrl = new URI(appSettings.startSPANPlusSvcURL)
                                            .segment(['contractpreflight', 'validfields', encryptedIds]);

                                    commonRESTCallService.getFromServer(getValidFieldsUrl.toString())
                                        .success(function examineValidFields(validFields) {
                                            var fields = mapRequiredFields(validFields);
                                            //var flattenedFields = [fields.customer, fields.deal, fields.vehicle, fields.lender, fields.contract ]
                                            //    .reduce(function(prev, curr) { return prev.concat(curr); });
                                            //contractInfoService.validFields = flattenedFields;
                                            transferValidFields(fields);

                                            contractCreationService.contractsProcessing.started = false;
                                            deferred.reject(error);
                                        }, function(innerError) {
                                            // the error checking for the error failed. PANIC
                                            var errorMsg = {
                                                reason: innerError[0] || '',
                                                endpoint: getValidFieldsUrl
                                            };
                                            contractCreationService.contractsProcessing.started = false;
                                            deferred.reject(error);
                                        });
                            });
                    }
                }
            }).error(function (data, status) {
                contractCreationService.contractsProcessing.started = false;
                deferred.reject(status + ' ' + JSON.stringify(data));
            });

            return deferred.promise;
        };

        function transferRequiredFields(mappedRequiredFields) {
            mappedRequiredFields.customer.forEach(function (requiredCustomerField) {
                contractInfoService.requiredFields.customer.push(requiredCustomerField);
            });

            mappedRequiredFields.contract.forEach(function (requiredContractField) {
                contractInfoService.requiredFields.contract.push(requiredContractField);
            });

            mappedRequiredFields.deal.forEach(function (requiredDealField) {
                contractInfoService.requiredFields.deal.push(requiredDealField);
            });

            mappedRequiredFields.vehicle.forEach(function (requiredVehicleField) {
                contractInfoService.requiredFields.vehicle.push(requiredVehicleField);
            });

            mappedRequiredFields.lender.forEach(function (requiredLenderField) {
                contractInfoService.requiredFields.lender.push(requiredLenderField);
            });
        }

        function transferValidFields(mappedValidFields) {
            mappedValidFields.customer.forEach(function (validCustomerField) {
                contractInfoService.validFields.customer.push(validCustomerField);
            });

            mappedValidFields.contract.forEach(function (validContractField) {
                contractInfoService.validFields.contract.push(validContractField);
            });

            mappedValidFields.deal.forEach(function (validDealField) {
                contractInfoService.validFields.deal.push(validDealField);
            });

            mappedValidFields.vehicle.forEach(function (validVehicleField) {
                contractInfoService.validFields.vehicle.push(validVehicleField);
            });

            mappedValidFields.lender.forEach(function (validLenderField) {
                contractInfoService.validFields.lender.push(validLenderField);
            });
        }

        //use the API to create contracts now that we are ready
        contractCreationService.generateContractForQuotes = function(quoteIds, isDraft, dateOfSale) {
            var deferred = $q.defer();

            contractCreationService.contractsProcessing.started = true;
            var encQuoteIds = quoteIds.map(function(quoteId) { return rateQuotePersistService.getEncryptedQuoteId(quoteId); });
            var encOrigQuoteId = _.object( encQuoteIds, quoteIds );
            var contractNumbers = quoteIds.map(function(quoteId) { return contractCreationService.getContractNumber(quoteId) || null; });

            var quotes = rateQuoteCoordService.getQuotesForScenario(rateQuoteScenariosService.getCurrentScenario());

            var sppQuoteIds = quotes
                .filter(function (quote){ return contractCreationService.getCreationStatus(quote.RatedTerms[0].SavedRateUniqueId);})
                .filter(function (quote){ return contractCreationService.getCreationStatusSPP(quote.RatedTerms[0].SavedRateUniqueId);})
                .map(function(quote) { return quote.RatedTerms[0].SavedRateUniqueId; })

            //if any draft contracts created... archive them
            quoteContractArchivalService.archiveContractsForQuote(quoteIds, encQuoteIds)
                .then(
                function readyToCreateNewContracts(results) {
                    //quoteIds assumed to be an array of integers
                    var templateUrl = appSettings.startSPANPlusSvcURL + "productcontracts/create-contract-template";
                    commonRESTCallService.getFromServer(templateUrl)
                    .success(function readyToFillInContractInfo(data, status) {
                            var contractReq = data;
                            //clear out any existing errormessages
                            contractInfoService.contractErrMsgPerQuote = {};

                            contractReq.providerCode = imSessionVarsService.getCurrentProviderCode();
                            contractReq.statusName = isDraft ? "DRAFT" : "OFFICIAL";
                            contractReq.dealerId = erateSessionVarsSvc.getCurrentDealerSPANId();
                            contractReq.dateOfSale = dateOfSale;
                            contractReq.integrationFields = null;
                            contractReq.quoteIds = encQuoteIds;
                            contractReq.contractNumbers = contractNumbers;  // for alt finance, same order as quote ids.  Null means corresponding quote is NOT alt financed.
                            contractReq.sppquoteIds = sppQuoteIds;
                            contractReq.tlApplication = 'TLCOMMERCE';
                            commonRESTCallService.postToServer(
                                appSettings.startSPANPlusSvcURL + "productcontracts/create-contract",
                                contractReq
                            )
                            .success(function contractCreatedNowSetupContractInfo(data, status) {
                                var i=0;
                                data.forEach(function setupUrlInfoForContract(contractData) {
                                    //we assume that if we get a contract number we are good.
                                    //if (!(contractData.providerErrMsg && contractData.providerErrMsg.length > 0)) {
                                    if ((contractData.providerContractNum && contractData.providerContractNum.length > 0)) {
                                        var status = contractData.statusName.toUpperCase();
                                        contractInfoService.contractInfo[contractData.Url] = {
                                            providerContractNumber: contractData.providerContractNum,
                                            formName: contractData.formName,
                                            status: contractData.statusName,
                                            contractId : contractData.contractId
                                        };
                                        contractCreationService.allowCreateNewContract[contractData.Url] = status != 'OFFICIAL';
                                        contractCreationService.contractsProcessing.officialContractsCreated |= (!isDraft);
                                        contractData.quoteIds.forEach(function (quoteId) {
                                            if (!contractInfoService.contractsPerQuote[encOrigQuoteId[quoteId]])
                                                contractInfoService.contractsPerQuote[encOrigQuoteId[quoteId]] = [];
                                            if (contractInfoService.contractsPerQuote[encOrigQuoteId[quoteId]].indexOf(contractData.Url) < 0) {
                                                contractInfoService.contractsPerQuote[encOrigQuoteId[quoteId]].push(
                                                    contractData.Url
                                                );
                                            }
                                            //prevent from re-submitting an OFFICIAL contract
                                            contractCreationService.clearACreationStatus(quoteId);
                                        });
                                        i = i + 1;
                                    }else{
                                        contractData.quoteIds.forEach(function (quoteId) {
                                            //prevent from re-submitting an OFFICIAL contract
                                            contractCreationService.clearACreationStatus(quoteId);
                                            contractInfoService.clearQuoteStatuses(quoteId);
                                            var providerErrMsg = {type: 'error', message: contractData.providerErrMsg},
                                                genericErrMsg = {type: 'error', message: 'Unknown error creating contract. Please retry.'};
                                            contractInfoService.contractErrMsgPerQuote[quoteId] = contractData.providerErrMsg ? providerErrMsg : genericErrMsg;
                                        });
                                    }
                                });
                                usageEventsService.contractCreated(i);
                                contractCreationService.contractsProcessing.completedLookup = true;
                                contractCreationService.contractsProcessing.contractsCreated = true;
                                contractReq = null;
                                deferred.resolve(data);
                            })
                            .error(function (data, status) {
                                contractCreationService.contractsProcessing.completedLookup = true;
                                var error = {
                                    status: status,
                                    reason: data,
                                    data: contractReq
                                };
                                contractReq = null;
                                deferred.reject(error);
                            });
                        })
                    .error(function (data, status) {
                            deferred.reject(status + ' ' + JSON.stringify(data));
                        });
                }
            )
            .catch(function(reason){
                deferred.reject(reason);
            });

            return deferred.promise;
        };

        //get the PDF from the URL returned from contract generation
        contractCreationService.getContractPDF = function(url){
            var deferred = $q.defer();

            commonRESTCallService.getFromServer(url)
                .success(function (data, status) {
                    deferred.resolve(data);
                })
                .error(function(data, status){
                    deferred.reject(status + ' ' + data);
                });

            return deferred.promise;
        }

        function mapRequiredFields(requiredFields) {
            var customerMapping = {};
            customerMapping['customer.CustomerNumber'] = 'customerNumber';
            customerMapping['customer.FirstName'] = 'BuyerInfo.firstName';
            customerMapping['customer.LastName'] = 'BuyerInfo.lastName';
            customerMapping['customer.CustomerAddressLine1'] = 'address1';
            customerMapping['customer.City'] = 'city';
            customerMapping['customer.State'] = 'state';
            customerMapping['customer.Zip'] = 'zip';
            customerMapping['customer.CustomerPhone'] = 'phone1';
            customerMapping['customer.BusinessName'] = 'BusinessInfo.businessName';
            customerMapping['customer.DriverFirstName'] = 'BusinessInfo.driverFirstName';
            customerMapping['customer.DriverLastName'] = 'BusinessInfo.driverLastName';

            var dealMapping = {};
            dealMapping['deal.PurchasePrice'] = 'sellingPrice';
            dealMapping['deal.AmountFinanced'] = 'amountFinanced';

            var vehicleMapping = {};
            vehicleMapping['vehicle.InternalVINId'] = 'vin';
            vehicleMapping['vehicle.Make.MakeName'] = 'makeName';
            vehicleMapping['vehicle.Model.SeriesName'] = 'modelName';
            vehicleMapping['other.InserviceDate'] = 'inService';

            var lenderMapping = {};
            lenderMapping['other.LenderName'] = 'name';


            var contractMapping = {};
            contractMapping['ps.etchStencilNum'] = 'etchStencilNum';
            contractMapping['ps.etchNum'] = 'etchNum';
            contractMapping['ps.etchSecNum'] = 'etchSecNum';
            contractMapping['ps.keycareContractNum'] = 'keycareContractNum';
            contractMapping['ps.performancePoints'] = 'performancePoints';
            contractMapping['ps.performancePoints1'] = 'performancePoints1';
            contractMapping['ps.performancePoints2'] = 'performancePoints2';
            contractMapping['ps.amountFinanced'] = 'amountFinanced';

            var mappedFields = {
                customer: filterRequiredFields(requiredFields, customerMapping),
                deal : filterRequiredFields(requiredFields, dealMapping),
                vehicle :  filterRequiredFields(requiredFields, vehicleMapping),
                lender : filterRequiredFields(requiredFields, lenderMapping),
                contract : filterRequiredFields(requiredFields, contractMapping)
            };

            return mappedFields;
        }

        function filterRequiredFields(requiredFields, mapping) {
            return requiredFields.filter(function(element) {
                return mapping[element];
            }).map(function(element){
                return mapping[element];
            });
        }

        contractCreationService.allRequiredFieldsFilled = function(customerDefinition, contractInfo, dealInfo, selectedLender, vehicleInfo) {
           var isGap = false;

            for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {
                if (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('GAP') > -1) { isGap=true; break; }

            }

            if(isGap)
            {
                var isValid = checkRequiredCustomerInfo(contractInfoService.requiredFields.customer, customerDefinition)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.contract, contractInfo)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.deal, dealInfo)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.lender, selectedLender)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.vehicle, vehicleInfo)
                    && ( (selectedLender.name != 'Not Applicable' && selectedLender.name != '' && selectedLender.name != 'undefined'
                        && selectedLender != 'Not Applicable' && selectedLender != '' && selectedLender != 'undefined')

                    );
                /*if(!isValid)
                {
                    selectedLender=null;
                }*/
            }
            else {
                var isValid = checkRequiredCustomerInfo(contractInfoService.requiredFields.customer, customerDefinition)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.contract, contractInfo)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.deal, dealInfo)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.lender, selectedLender)
                    && checkRequiredFieldSection(contractInfoService.requiredFields.vehicle, vehicleInfo);

            }

            if (checkRequiredFieldSection(contractInfoService.requiredFields.contract, contractInfo) == true){
                $rootScope.$broadcast('ContractFieldsCompleted', {completed: true});
            }
            else{
                $rootScope.$broadcast('ContractFieldsCompleted', {completed: false});
            }

            return isValid;
        };

        function checkRequiredCustomerInfo(requiredFields, dataObject) {
            var fieldName = '';
            var buyerFirstInfoFilled = false;
            var buyerLastInfoFilled = false;
            var businessNameFilled = false;
            var businessDriverFirstFilled = false;
            var businessDriverLastFilled = false;
            var nameRequired = false;
            for(var i = 0; i < requiredFields.length; i++) {
                fieldName = requiredFields[i];

                switch(fieldName) {
                    case 'BuyerInfo.firstName' : {
                        if(evaluateFullFieldName(fieldName, dataObject))
                            buyerFirstInfoFilled = true;
                        nameRequired = true;
                        break;
                    }
                    case 'BuyerInfo.lastName' : {
                        if(evaluateFullFieldName(fieldName, dataObject))
                            buyerLastInfoFilled = true;
                        nameRequired = true;
                        break;
                    }
                    case 'BusinessInfo.businessName' : {
                        if(evaluateFullFieldName(fieldName, dataObject))
                            businessNameFilled = true;
                        nameRequired = true;
                        break;
                    }
                    case 'BusinessInfo.driverFirstName' : {
                        if(evaluateFullFieldName(fieldName, dataObject))
                            businessDriverFirstFilled = true;
                        nameRequired = true;
                        break;
                    }
                    case 'BusinessInfo.driverLastName' : {
                        if(evaluateFullFieldName(fieldName, dataObject))
                            businessDriverLastFilled = true;
                        nameRequired = true;
                        break;
                    }
                    default : {
                        if(!evaluateFullFieldName(fieldName, dataObject)) {
                            return false;
                        }
                    }
                }
            }

            return (buyerFirstInfoFilled && buyerLastInfoFilled) || (businessNameFilled && businessDriverLastFilled && businessDriverFirstFilled) || !nameRequired;
        }

        function checkRequiredFieldSection(section, dataObject) {
            var fieldName = '';
            for(var i = 0; i < section.length; i++) {
                fieldName = section[i];
                if(!evaluateFullFieldName(fieldName, dataObject)) {
                    return false;
                }
            }
            return true;
        }

        function evaluateFullFieldName(fieldNameString, destinationObject) {
            if(fieldNameString.indexOf('.') === -1) {
                return destinationObject[fieldNameString];
            } else {
                var propertyName = fieldNameString.substring(0, fieldNameString.indexOf('.'));
                var newFieldNameString = fieldNameString.substring(fieldNameString.indexOf('.') + 1);

                if (!destinationObject[propertyName]) {
                    throw new Error("Property '" + propertyName + "' not found in destination object: " + destinationObject);
                } else {
                    return evaluateFullFieldName(newFieldNameString, destinationObject[propertyName]);
                }
            }
        }

        contractCreationService.createOfficialContract = function(quoteId) {
            var deferred = $q.defer();
            if(!quoteId)
                deferred.reject(new Error('No quote selected'));

            contractInfoService.quoteQueueInfo.loading[quoteId] = true;

            var dateOfSale = new Date();
            if (rateQuoteCoordService.VehicleData && rateQuoteCoordService.VehicleData.dateOfSale)
                dateOfSale = new Date(rateQuoteCoordService.VehicleData.dateOfSale);

            //at this point we should not need to "attempt" contract creation with preflight,
            // since we should already have created a draft, which went thru preflight
            contractCreationService.generateContractForQuotes([quoteId], false, dateOfSale)
                .then(
                    function completedGeneratingContracts(result){
                        contractCreationService.contractsProcessing.started = false;
                        contractInfoService.quoteQueueInfo.loading[quoteId] = false;
                        deferred.resolve(true);
                    },
                    function(err){
                        contractCreationService.contractsProcessing.started = false;
                        contractInfoService.quoteQueueInfo.loading[quoteId] = false;
                        deferred.reject(err);
                    }
                );

            return deferred.promise;
        };

    contractCreationService.getPerformancePointsMode = function(){
        var deferred = $q.defer();

        var modeUrl = appSettings.startSPANPlusSvcURL + 'contractpreflight/performance-points-mode/'
            + imSessionVarsService.getCurrentProviderCode();

        commonRESTCallService.getFromServer(modeUrl)
        .success(
            function gotPFUIMode(mode) {
                deferred.resolve(mode.performancePointsMode);
            }
        )
        .error(
            function (data, status) {
                deferred.reject(status + ' ' + JSON.stringify(data));
            }
        );

        return deferred.promise;

    }

    contractCreationService.providerAllowsDraft = function(){
        var deferred = $q.defer();

        var modeUrl = appSettings.startSPANPlusSvcURL + 'productcontracts/allows-draft/'
            + imSessionVarsService.getCurrentProviderCode();

        commonRESTCallService.getFromServer(modeUrl)
        .success(
            function gotDraftMode(mode) {
                deferred.resolve(mode.allowsDraft);
            }
        )
        .error(
            function (data, status) {
                deferred.reject(status + ' ' + JSON.stringify(data));
            }
        );

        return deferred.promise;
    }

    contractCreationService.canCreateContractForQuote = function(quoteId){
        var deferred = $q.defer();

        if (quoteId) {
            var modeUrl = appSettings.startSPANPlusSvcURL + 'productcontracts/allows-contract/'
                + imSessionVarsService.getCurrentProviderCode() + '/' + quoteId;

            commonRESTCallService.getFromServer(modeUrl)
                .success(
                    function gotCanCreate(allowed) {
                        deferred.resolve(allowed.allowCreate);
                    }
                )
                .error(
                    function (data, status) {
                        deferred.reject(status + ' ' + JSON.stringify(data));
                    }
                );
        }else{deferred.resolve(false);}
        return deferred.promise;
    }

    return contractCreationService;
    }]);
